export default __webpack_public_path__ + "static/media/slide2.a84700da.png";